/**
 * Campaign Demo Mode (web)
 * When enabled, users can try booking/favorites locally.
 * Nothing is written to Supabase / Stripe.
 *
 * Enable: "Try Demo" on the login modal
 * Disable: Exit demo banner, clearDemoMode(), or DEMO_CAMPAIGN_ENABLED = false
 */

export const DEMO_STORAGE_KEY = 'tts_demo_mode'
// Valid UUID shape so any stray query/filter does not fail Postgres type checks
export const DEMO_USER_ID = '00000000-0000-4000-8000-000000000001'
export const DEMO_ENABLED_EVENT = 'tts-demo-mode-changed'

/** Fake signed-in user used only while demo mode is active */
export const DEMO_AUTH_USER = {
  id: DEMO_USER_ID,
  email: 'demo@timelesstrends.demo',
  user_metadata: {
    role: 'customer',
    full_name: 'Demo User',
    first_name: 'Demo',
    last_name: 'User',
    is_demo: true,
  },
  app_metadata: { provider: 'demo' },
  _demo: true,
}

export const DEMO_PROFILE = {
  id: DEMO_USER_ID,
  first_name: 'Demo',
  last_name: 'User',
  full_name: 'Demo User',
  email: 'demo@timelesstrends.demo',
  mobile: '0000000000',
  country_code: '+1',
  date_of_birth: '1995-01-01',
  gender: '',
  role: 'customer',
  account_status: 'active',
  profile_image_url: null,
  avatar_url: null,
  _demo: true,
}

/** Feature switch — set false after campaign to kill all demo entry points */
export const DEMO_CAMPAIGN_ENABLED = true

export const isDemoMode = () => {
  if (!DEMO_CAMPAIGN_ENABLED) return false
  try {
    return sessionStorage.getItem(DEMO_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const setDemoMode = (enabled) => {
  try {
    if (enabled && DEMO_CAMPAIGN_ENABLED) {
      sessionStorage.setItem(DEMO_STORAGE_KEY, 'true')
    } else {
      sessionStorage.removeItem(DEMO_STORAGE_KEY)
    }
    window.dispatchEvent(new CustomEvent(DEMO_ENABLED_EVENT, { detail: { enabled: !!enabled && DEMO_CAMPAIGN_ENABLED } }))
  } catch (e) {
    console.warn('Demo mode storage failed:', e)
  }
}

export const clearDemoMode = () => {
  try {
    clearDemoStoreSafe()
  } catch (_) { /* ignore */ }
  setDemoMode(false)
}

function clearDemoStoreSafe() {
  try {
    sessionStorage.removeItem('tts_demo_store')
    sessionStorage.removeItem('tts_demo_preferred_salon_id')
  } catch (_) { /* ignore */ }
}

export const getDemoUserId = () => DEMO_USER_ID
